import React from 'react';


function FormattedCurrencyNumberCustom(props) {
  const currPorps = props;
  const value = currPorps.value;
  const direction = currPorps.currencyDirection ? currPorps.currencyDirection : 'left';
  const LOCAL_STORAGE_KEY = 'redux_state';
  const persistedState = localStorage.getItem(LOCAL_STORAGE_KEY);
  const store = persistedState ? JSON.parse(persistedState) : {};
  const user = store.user;
  const currency = user.locale === 'fr-CM' ? 'CFA' : (currPorps.currency ? currPorps.currency : user.currency);
  const userLocale = (user.language && user.language.locale) ? user.language.locale : user.locale;
  const thousandSep = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 })
  .format(value);
  return (
    <span className="custom-formated-currency">
      { direction === 'right' &&
        <span>
          {thousandSep} {currency}
        </span>
      }
      { direction !== 'right' &&
        <span>
          {currency} {thousandSep}
        </span>
      }
    </span>
  );
}
export default FormattedCurrencyNumberCustom;
